export default __webpack_public_path__ + "static/media/flower2.51fdb20f.jpg";